import { gtagInit, gtag } from '@codestreet/analytics'

export default defineNuxtPlugin({
  setup() {
    gtagInit()
    gtag('js', new Date())
  },
})
